import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Link } from "react-router-dom";

const StoreCard = ({ seller, texts }) => {
  const isTablet = useMediaQuery("(max-width: 1000px)");
  const isMobile = useMediaQuery("(max-width: 768px)");
  return (
    <div
      className="store-card"
      style={{
        width: isMobile ? "60%" : isTablet ? "30%" : "33%",
        minWidth: isMobile ? "60%" : "auto",
        margin: "0px 13.5px",
      }}
    >
      <div className="relative" style={{ height: 136 }}>
        <div className="location-shopping">
          {seller.seller.map_url && (
            <a
              href={seller.seller.map_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="49"
                height="48"
                viewBox="0 0 49 48"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g fill="none" fill-rule="evenodd">
                  <path d="M12.016 12h24v24.001h-24z" />
                  <path d="M12.016 12h24v24.001h-24z" />
                  <g fill="#FFF" fill-rule="nonzero">
                    <g transform="translate(14.533 13.002)">
                      <path d="M9.484 17a1 1 0 0 1-.91-.586C7.89 14.914 4.484 7.31 4.484 5c0-2.757 2.243-5 5-5s5 2.243 5 5c0 2.31-3.406 9.914-4.09 11.414a.995.995 0 0 1-.91.586zm0-15c-1.654 0-3 1.346-3 3 0 1.183 1.593 5.261 3 8.527 1.408-3.267 3-7.345 3-8.527 0-1.654-1.345-3-3-3z" />
                      <circle cx="9.484" cy="5" r="1.5" />
                      <path d="M16.968 20H2a1.996 1.996 0 0 1-1.67-.898 1.991 1.991 0 0 1-.167-1.891l2.142-4.998a1.995 1.995 0 0 1 1.838-1.212h.824v2h-.824l-2.143 5h14.967l-2.143-5h-.857v-2h.857c.802 0 1.523.476 1.838 1.213l2.142 4.999a1.991 1.991 0 0 1-.168 1.888 1.994 1.994 0 0 1-1.67.899z" />
                    </g>
                  </g>
                </g>
              </svg>
            </a>
          )}
        </div>

        {seller?.on_sale && (
          <div className="sales">
            <strong>{texts["onSale"]}</strong>
          </div>
        )}
        <img
          className="w-100 store-img"
          src={seller.seller.logo ? seller.seller.logo : "/static/img/273.png"}
          target="_blank"
          rel="noopener noreferrer"
          alt="Seller Logo"
        />
      </div>
      <div className="texts-body">
        <h4 className="title text-right">{seller.seller.name}</h4>
        <div style={{ height: 70 }}>
          <p className="d-flex align-items-center" style={{ direction: "rtl" }}>
            <img
              src="./static/img/combined-shape-2.svg"
              style={{ margin: 0 }}
            />
            <span style={{ marginRight: 10, color: "#727d93", fontSize: 10 }}>
              {seller.seller.phone ? seller.seller.phone : "-"}
            </span>
          </p>

          <p className="d-flex mt-2" style={{ direction: "rtl" }}>
            <img src="./static/img/shape-2.svg" style={{ margin: 0 }} />
            <span style={{ marginRight: 10, color: "#727d93", fontSize: 10 }}>
              {seller.seller.address ? seller.seller.address : "-"}
            </span>
          </p>
        </div>
        {!seller.type ? (
          <div className="d-flex justify-content-between">
            <a
              href={seller.buy_url ? seller.buy_url : "#"}
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex justify-content-center align-items-center"
              style={{
                backgroundColor: "#06b170",
                borderRadius: 10,
                color: "#fff",
                height: 45,
                margin: 0,
                width: "73%",
              }}
            >
              درخواست پرو
            </a>
            <a
              href={seller.buy_url ? seller.buy_url : "#"}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                backgroundColor: "#de2a35",
                borderRadius: 10,
                color: "#fff",
                height: 45,
                margin: 0,
                width: "24%",
              }}
              className="d-flex justify-content-center align-items-center"
            >
              <img
                src="./static/img/icon-c-copy-37.svg"
                style={{ margin: 0 }}
              />
            </a>
          </div>
        ) : (
          <Link to={seller.seller.link}>
            <button
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex justify-content-center align-items-center"
              style={{
                backgroundColor: "#06b170",
                borderRadius: 10,
                color: "#fff",
                height: 45,
                margin: 0,
                width: "100%",
              }}
            >
              ارسال طرح
            </button>
          </Link>
        )}

        <a
          href={seller.buy_url ? seller.buy_url : "#"}
          target="_blank"
          rel="noopener noreferrer"
        ></a>
      </div>
    </div>
  );
};

export default StoreCard;
